/**
 * Function to validate if the two given objects are deeply equal
 *
 * @template T
 * @param {T} obj1
 * @param {T} obj2
 *
 * @example
 * areObjectsEqual({x: 1, y: 1}, {x: 1, y: 1});
 * // return true
 *
 * @return {*}  {boolean}
 */
export var areObjectsEqual = function (obj1, obj2) {
    if (obj1 === obj2)
        return true;
    if (typeof obj1 !== 'object'
        || typeof obj2 !== 'object'
        || obj1 == null
        || obj2 == null)
        return false;
    var keysA = Object.keys(obj1);
    var keysB = Object.keys(obj2);
    if (keysA.length !== keysB.length) {
        return false;
    }
    var result = true;
    keysA.forEach(function (key) {
        if (!keysB.includes(key))
            result = false;
        if (!areObjectsEqual(obj1[key], obj2[key]))
            result = false;
    });
    return result;
};
//# sourceMappingURL=areObjectsEqual.js.map